import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const UndoIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.4401 6.68001C11.7071 6.68001 12.9071 6.94001 14.0401 7.46001C15.1325 7.96597 16.1093 8.69095 16.9101 9.59001C17.7223 10.4901 18.3387 11.5491 18.7201 12.7L16.7601 13.32C16.4826 12.4443 16.0186 11.6392 15.4001 10.96C14.7851 10.2753 14.0364 9.72398 13.2001 9.34001C12.3331 8.94001 11.4131 8.74001 10.4401 8.74001C9.64005 8.74001 8.86705 8.88001 8.12005 9.16001C7.39456 9.42209 6.72341 9.81529 6.14005 10.32L9.18005 13.32H1.68005V5.82001L4.64005 8.82001C5.41859 8.1448 6.31304 7.61626 7.28005 7.26001C8.28881 6.87418 9.36003 6.67756 10.4401 6.68001Z'
                fill='currentColor'
            />
        </>
    ),
})

UndoIcon.displayName = 'UndoIcon'
